export default "__VITE_ASSET__BDGUeoie__"